CoursesController.$inject = ['$rootScope', 'CourseService', '$stateParams', '$timeout', '$state']

export default function CoursesController($rootScope, CourseService, $stateParams, $timeout, $state) {
  var vm = this

  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      CourseService.getCourses(profileId).then(res => vm.courses = res.data)
    }
  })

  vm.currentPage = $stateParams.page
  vm.pageSize = 24
  vm.maxSize = 5

  vm.setSortBy = function(property) {
    var copy = vm.courses
    vm.courses = null
    function compare(a, b) {
      let comparison = 0
      if (a[property] > b[property]) {
        comparison = vm.sortChanged ? -1 : 1
      } else if (a[property] < b[property]) {
        comparison = vm.sortChanged ? 1 : -1
      }
      return comparison
    }
    copy.sort(compare)
    vm.sortChanged = !vm.sortChanged
    $timeout(function() {
      vm.courses = copy
    }, 100)
  }
  vm.numberOfPages = function() {
    return parseInt(vm.courses.length / vm.pageSize)
  }
  vm.pageChanged = function(currentPage) {
    $state.go('.', { page: currentPage }, { notify: false })
  }
}